import {
  ALERTS_FIRE,
  ALERTS_LAW_ENFORCEMENT,
  ALERTS_MEDICAL,
  ALERTS_ACTIVE_ASSAILANT,
  ALERTS_NOTIFICATION,
  ALERTS_TRAIN_INCIDENT,
} from '@rsos/capstone/src/constants/capabilities';

const ALERT_TYPES = [
  ALERTS_FIRE,
  ALERTS_LAW_ENFORCEMENT,
  ALERTS_MEDICAL,
  ALERTS_ACTIVE_ASSAILANT,
  ALERTS_TRAIN_INCIDENT,
];

/**
 * Function to determine if the current user's authority has an alerts
 * capability turned on and if the user has permission to view alerts
 * @param {Object} sinatra - Sinatra reducer
 * @param {Object} psaps - PSAPS reducer
 */

const canViewAlerts = (sinatra, psaps) => {
  const hasAlertsPermission = !!(
    sinatra.user.currentRole &&
    sinatra.user.currentRole.permissions &&
    sinatra.user.currentRole.permissions.includes('ALERTS')
  );
  const isAnyAlertsCapabilityEnabled = !!(
    psaps.currentPSAP &&
    psaps.currentPSAP.activeCapabilities &&
    Object.keys(psaps.currentPSAP.activeCapabilities).some(capability =>
      ALERT_TYPES.includes(capability),
    )
  );
  const isAlertsNotificationCapabilityEnabled = !!(
    psaps.currentPSAP &&
    psaps.currentPSAP.activeCapabilities &&
    psaps.currentPSAP.activeCapabilities[ALERTS_NOTIFICATION]
  );
  return (
    (hasAlertsPermission && isAnyAlertsCapabilityEnabled) ||
    isAlertsNotificationCapabilityEnabled
  );
};

export default canViewAlerts;
